import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TableauService } from "../core/tableau.service";
import { UserProfileService } from '../core/userProfile.service';

@Component({
  selector: 'reportpdfviewer',
  templateUrl: './reportpdfviewer.component.html',
  styleUrl: './reportpdfviewer.component.css'
})
export class ReportpdfviewerComponent {

  constructor( private route: ActivatedRoute, private router: Router, private tableauService: TableauService, private userProfileService: UserProfileService ){}
  currentReportUrl : string;
  selectedWorkbook : any;
  @Input() url: string;



  public ngOnInit() {
    if (!this.url ) {
      this.route.params.subscribe( async (params) => {

        const allWorkbooks = await this.tableauService.getAllWorkBooks('');
        const selectedWorkBook = allWorkbooks.find( x => x.workBookId === params.reportId );
        if ( selectedWorkBook ){
          this.currentReportUrl = selectedWorkBook.customReportUrl;
          this.selectedWorkbook = selectedWorkBook;
        }

      });
    }
    else {
      this.currentReportUrl = this.url;
    }
  }

  goBack(){
    const navigationDetails: string[] = [`/report`];
    this.router.navigate(navigationDetails);
  }

  async setDashBoard(){
    await this.tableauService.setDashboard(this.userProfileService.userEmail, 
                                            null, 
                                            this.selectedWorkbook.workbookName,
                                            this.selectedWorkbook.workBookId,
                                            this.selectedWorkbook.parentProject.name,
                                            this.userProfileService.userEmail,
                                            null,
                                            this.selectedWorkbook.customReportUrl);

    // Redirect back to the home page                                       
    const navigationDetails: string[] = ['/'];
    this.router.navigate(navigationDetails);                                         
  }
}
